import React from "react";

const UpperLine = () => {
    return (
        <svg
            width="228"
            height="94"
            viewBox="0 0 228 94"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_d_1077_13176)">
                <path
                    d="M5 85C35.6517 41.4177 132.141 -30.1984 223 15.902"
                    stroke="#007FB6"
                    strokeWidth="2"
                    strokeDasharray="5 5"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_1077_13176"
                    x="0.182129"
                    y="0.0175781"
                    width="227.271"
                    height="93.5586"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1077_13176"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1077_13176"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};

export default UpperLine;
